import { Component, OnInit } from '@angular/core';
import {Cardmaster} from "../models/cardmaster";
import {CardService} from "../services/card.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
declare var $ :any;
declare var bootbox: any;
import {ActivatedRoute} from "@angular/router";



@Component({
  selector: 'app-cardlist',
  templateUrl: './cardlist.component.html'
})
export class CardlistComponent implements OnInit {

    p: number[] = [];
    searchText: string = '';
    category_id: number = 0;

    cardlist:Cardmaster[];

    constructor(
        private cardService:CardService,
        private router:Router,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        console.log(this.activatedRoute)
        this.activatedRoute.params.subscribe(params => {
            if(params['id']){
                this.category_id = params['id'];
            }
            console.log("CardImageId======>",this.category_id); // Print the parameter to the console.
        });

        this.getCards(0,{sortColumn: 'card_id', sortDirection:'desc'});
        // $(document).ready(function() {
        //     $("#datatable").DataTable();
        // });
    }

    onSorted($event){
        this.getCards(0,$event);
    }

    viewCardImages(card_id){
        this.router.navigate(['/cards/cardimages/',card_id]);
    }

    viewCardTexts(card_id){
        this.router.navigate(['/cards/cardtexts/',card_id]);
    }

    getCards=function(pageId,criteria: CardListSearchCriteria){
        this.cardService.getCardList(pageId,this.searchText,this.category_id).then(data => {
            console.log("CardList =======>",data);
            this.cardlist = data['data']['data'];
            this.totaloffset = data['data'].Totaloffset;
            this.itemsperpage = data['data'].ItemsPerPage;
            this.SortCards(criteria);
        });
    }

    SortCards(criteria: CardListSearchCriteria): Cardmaster[] {
        return this.cardlist.sort((a,b) => {
          if(criteria.sortDirection === 'desc'){
            if (a[criteria.sortColumn] < b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
          else {
            if (a[criteria.sortColumn] > b[criteria.sortColumn]) {
                return 1
            } else {
                return 0
            }
          }
        });
    }

    viewCard(card_id){
        this.router.navigate(['/cards/',card_id]);
    }

    deleteCard(card_id,i){
        this.cardService.deleteCardCall(card_id).then(data => {
            console.log(data['code'])
            if(data['code'] === 200){
                $.toast({heading: 'Success', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
                this.getCards(0,{sortColumn: 'card_name', sortDirection:'desc'});
                // this.router.navigate(['/cards']);
            }else{
                $.toast({heading: 'Warning', text: data['message'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            }
        }).catch(err => {
            if(err['code'] != 200){
                $.toast({heading: 'Error', text: err['message'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }else{
                $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
            }
        });
    }

    deleteCardConfirm(card_id,i){
        var _this = this;
        bootbox.confirm({
            message: "Are you sure you want to delete this record?",
            buttons: {
                confirm: {label: 'Yes',className: 'btn-success btn-flat'},
                cancel: {label: 'No',className: 'btn-default btn-flat'}
            },
            callback: function (result) {
                if(result) {
                    _this.deleteCard(card_id,i);
                }
            }
        });
    }

}

export class CardListSearchCriteria {
    sortColumn: string;
    sortDirection: string;
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/cardsmaster/cardlist/cardlist.component.ts